import React from 'react';
import RichText from '../rich-text';
import Link from '../link';
import { NovartisLogo } from '../../../../assets/images/novartis-logo';
import useTranslation from '../../../../hooks/useTranslation';
import useFooter from '../../../../hooks/useFooter';
import { EventPosition } from '../../../../services/analytics-interfaces';
import classNames from 'classnames';
import usePages from '../../../../hooks/usePages';
import { useProduct } from '../../../../hooks';

const NovartisFooter: React.FC = () => {
	const { t } = useTranslation();
	const { cookies } = usePages();
	const {
		params: { mlrVersion },
	} = useProduct();
	const {
		novartisFooter: { trademark },
	} = useFooter();
	return (
		<div
			className={classNames('flex flex-col gap-5 w-full py-6', {
				'pb-16 lg:pb-6': cookies,
			})}>
			{trademark && (
				<p className="text-xs pl-9 text-font-menu">
					<RichText html={t('footer.novartis.trademark')} />
				</p>
			)}
			<Link
				href={t('footer.novartis.url')}
				target="_blank"
				rel="noopener noreferrer"
				title={t('footer.novartis.logo')}
				alt={t('footer.novartis.alt')}
				aria-label={t('footer.novartis.alt')}
				position={EventPosition.Footer}>
				<NovartisLogo className="h-8 w-auto" />
			</Link>
			<div className="flex flex-col gap-5 text-xs pl-9 text-font-menu">
				<div>
					<RichText html={t('footer.novartis.copyright')} />
				</div>
				<p className="whitespace-pre">{mlrVersion}</p>
			</div>
		</div>
	);
};

export default NovartisFooter;

